import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import { SxProps, Theme, ThemeProvider } from '@mui/material/styles';
import AOS from 'aos';
import React, { useEffect, useState } from 'react';
import getTheme from '../theme';
import GlobalDialog from './organisms/GlobalDialog/GlobalDialog';
import CartDrawer from './molecules/CartDrawer';
import Preloader from './atoms/Preloader';
import { useWoocommerceContext } from '@/services/context/Woocommerce/WoocomerceProvider';
import { Box } from '@mui/material';

export const useDarkMode = (): [string, () => void, boolean] => {
    const [themeMode, setTheme] = useState('light');
    const [mountedComponent, setMountedComponent] = useState(false);

    const setMode = (mode: string) => {
        try {
            window.localStorage.setItem('themeMode', mode);
        } catch {
            /* do nothing */
        }

        setTheme(mode);
    };

    const themeToggler = (): void => {
        themeMode === 'light' ? setMode('dark') : setMode('light');
    };

    useEffect(() => {
        try {
            const localTheme = window.localStorage.getItem('themeMode');
            localTheme ? setTheme(localTheme) : setMode('light');
        } catch {
            setMode('light');
        }

        setMountedComponent(true);
    }, []);

    return [themeMode, themeToggler, mountedComponent];
};

interface Props {
    children: React.ReactNode;
    paperSx?: SxProps<Theme>;
}

export default function Page({ children, paperSx }: Props): JSX.Element {
    React.useEffect(() => {
        AOS.init({
            once: true,
            delay: 50,
            duration: 500,
            easing: 'ease-in-out',
        });
    }, []);

    const [themeMode, themeToggler, mountedComponent] = useDarkMode();

    useEffect(() => {
        AOS.refresh();
    }, [mountedComponent, themeMode]);

    return (
        <ThemeProvider theme={getTheme(themeMode, themeToggler)}>
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
            <Paper elevation={0} sx={paperSx}>
                {children}
            </Paper>
            <GlobalDialog />
            {/* <AcceptCookies /> */}
        </ThemeProvider>
    );
}
